import { render, staticRenderFns } from "./view-performance.vue?vue&type=template&id=bf5cc898&scoped=true&"
import script from "./view-performance.vue?vue&type=script&lang=js&"
export * from "./view-performance.vue?vue&type=script&lang=js&"
import style0 from "./view-performance.vue?vue&type=style&index=0&id=bf5cc898&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5cc898",
  null
  
)

export default component.exports